// @ts-nocheck
import { Action, AnyAction, createSlice } from '@reduxjs/toolkit';
export const initialState = {
    dashBoardData: null,
    isLoading: {},
};

const slice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        updateDashboardData(state, { payload: { data } }) {
            return {
                ...state,
                dashBoardData: data
            };
        },
        toggleLoader(state, { payload: { loaderComponent, isLoading } }) {
            return {
                ...state,
                isLoading: {
                    [loaderComponent]: isLoading
                }
            };
        },
    }
});

export default slice;

export const { updateDashboardData, toggleLoader } = slice.actions;
